import Moment from 'moment';

export default {
  error: null,
  loading: false,
  filters: {
    // YYYY-mm-dd
    date: '',
    // (legacy)id of Inspector object
    inspector: 0,
    // based on vuetify's date-picker format: YYYY-MM
    month: new Moment().format('YYYY-MM'),
    // hh:mm
    time: '',
  },
  records: [],
  inspectors: [],
};
